import { render, staticRenderFns } from "./CoverImgUploader.vue?vue&type=template&id=4064bcd1&scoped=true&"
import script from "./CoverImgUploader.vue?vue&type=script&lang=js&"
export * from "./CoverImgUploader.vue?vue&type=script&lang=js&"
import style0 from "./CoverImgUploader.vue?vue&type=style&index=0&id=4064bcd1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4064bcd1",
  null
  
)

export default component.exports